// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__TAlff","footerWrapper":"Footer_footerWrapper__5dcfu","footerContent":"Footer_footerContent__83Xiw"};